﻿import { Language } from '@lingvo-news/contracts';

export function getTextClass(lang: Language) {
	return 'main-text-' + lang;
}

export function getArticleTitleClass(lang: Language) {
	return 'article-title-' + lang;
}

export function getListTitleClass(lang: Language) {
	return 'list-title-' + lang;
}
